var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { Stack } from "syf-component-library/ui/spacing";
import { BigIcon, CenterStackedInset, FullHeightContainer, Subtitle, Title, } from "./subComponents";
var ErrorFallback = function (_a) {
    var error = _a.error;
    var isAPIError = error.name.includes("HTTPError");
    var mainErrorMessage = isAPIError
        ? "Statement Details Unavailable"
        : "Sorry, there was an unexpected problem!";
    return (_jsx(FullHeightContainer, { children: _jsxs(CenterStackedInset, __assign({ all: "xlarge" }, { children: [_jsx(BigIcon, { icon: faExclamationTriangle }), _jsx(Stack, { size: "xxlarge" }), _jsx(Title, { children: mainErrorMessage }), _jsx(Stack, { size: "xxlarge" }), _jsx(Subtitle, { children: "We are having trouble retrieving this information. Please reload the page or try again later." })] })) }));
};
export default ErrorFallback;
